// extracted by mini-css-extract-plugin
export default {"user-dropdown":"styles__user-dropdown--Armc+"};